import { render, staticRenderFns } from "./adTime.vue?vue&type=template&id=bdb5d6d0&scoped=true&"
import script from "./adTime.vue?vue&type=script&lang=js&"
export * from "./adTime.vue?vue&type=script&lang=js&"
import style0 from "./adTime.vue?vue&type=style&index=0&id=bdb5d6d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb5d6d0",
  null
  
)

export default component.exports